module.exports = __webpack_public_path__ + "static/30-747c4e824337501007503a5777ef0428.jpg";